import Mutations from '../../odata/mutations';

export default { ...new Mutations('mfcCode'), ...new Mutations('mfcCodes') };
